export const UNIDADE_MEDIDA_OPTIONS = [
  { name: 'Unidade', value: 1 },
  { name: 'Saco', value: 5 },
  { name: 'Metro', value: 6 }
];

export const STATUS_PRODUTO_OPTIONS = [
  { name: 'Ativo', value: 1 },
  { name: 'Desativo', value: 0 },
  { name: 'Suspenso', value: 2 }
];

export const TIPO_MOVIMENTACAO_OPTIONS = [
  { name: 'Todos', value: 0 },
  { name: 'Entrada', value: 1 },
  { name: 'Saída', value: 2 },
  { name: 'Ajuste', value: 3 }
];

export const ORIGEM_MOVIMENTACAO_OPTIONS = [
  { name: 'Todos', value: 0 },
  { name: 'Venda', value: 1 },
  { name: 'Entrada Manual', value: 2 },
  { name: 'Ajuste', value: 3 },
  { name: 'Cancelamento', value: 4 },
  { name: 'Saída Manual', value: 5 }
];

export const MODO_PAGAMENTO_OPTIONS = [
  { name: 'Cartão de Crédito', value: 1 },
  { name: 'Cartão de Débito', value: 19 },
  { name: 'Pix', value: 27 },
  { name: 'Dinheiro', value: 9 },
  { name: 'A Prazo', value: 28 }
];

export function labelUnidadeMedida(value: number): string {
  const labels: Record<number, string> = {
    1: 'Unidade',
    2: 'Kg',
    3: 'Litro',
    4: 'Caixa',
    5: 'Saco',
    6: 'Metro'
  };
  return labels[value] ?? UNIDADE_MEDIDA_OPTIONS.find(o => o.value === value)?.name ?? '---';
}

export function abrevUnidadeMedida(value: number): string {
  const labels: Record<number, string> = {
    1: 'UN',
    2: 'KG',
    3: 'LT',
    4: 'CX',
    5: 'SC',
    6: 'm'
  };
  return labels[value] ?? 'UN';
}

export function labelStatusProduto(value: number): string {
  return STATUS_PRODUTO_OPTIONS.find(o => o.value === value)?.name ?? '---';
}

export function labelTipoMovimentacao(value: number): string {
  return TIPO_MOVIMENTACAO_OPTIONS.find(o => o.value === value && o.value !== 0)?.name ?? String(value);
}

export function labelOrigemMovimentacao(value: number): string {
  return ORIGEM_MOVIMENTACAO_OPTIONS.find(o => o.value === value && o.value !== 0)?.name ?? String(value);
}
